import { DialogContentText } from '@mui/material';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import {FC} from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'thermia-react-container';
import { AdministrationCompletedForTable } from './adminRegistrationsTable';

interface Props {
  registration?: AdministrationCompletedForTable;
  onClose: () => void;
}

const InsuranceInfo: FC<Props> = ({ onClose, registration }) => {
  const { t } = useTranslation('registrations');

  const device = registration?.devices.filter(d => d.insurance) ?? [];
  if(device.length <= 0) {
    onClose();
  }
  
  return (
    <Grid container direction="column" justifyContent="center" alignItems="center">
        <>
          <DialogTitle>{t('registrations.admin.insuranceInfo')}</DialogTitle>
          <DialogContent>
            <DialogContentText paragraph>
              <span style={{ display: 'flex', flexDirection: 'row', gap: '1rem' }}>
                {device.map(d => (
                  <span key={d.serialNumber}>
                    <b>{d.articleName} ({d.serialNumber})</b><br />
                    <span style={{ display: 'grid', gridTemplateColumns: 'auto 1fr', columnGap: '0.75rem' }}>
                      <span>{t('registrations.admin.insuranceNumber')}:</span>
                      <span>{d.insurance!.insuranceNumber}</span>
                      <span>{t('registrations.admin.insurancePeriod')}:</span>
                      <span>{d.insurance!.startDate} &rarr; {d.insurance!.endDate}</span>
                    </span>
                  </span>
                ))}
              </span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} title={t('registrations.general.ok')} />
          </DialogActions>
        </>
    </Grid>
  );
};

export default InsuranceInfo;
